












import { ErrorCode, ErrorSeverity, ThrowErrorFunction, isDownstreamErrorCode } from "~/modules/error";
import { HttpAdapter } from "~/backend/HttpAdapter/HttpAdapter";
import { AuthenticationMethod } from "~/backend/commons/authenticationMethods";
import { throwFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";
import { SimpleHttpAdapterImpl } from "~/backend/SimpleHttpAdapter/SimpleHttpAdapterImpl";
import { ContextManager } from "~/modules/contextManager/ContextManager";
import { stringifyParams } from "~/utils/stringifyParams";

import { ConferenceRecording } from "../model/conferenceRecording";
import { UpdateConferenceRecordingRequest } from "../model/updateConferenceRecordingRequest";

import { ConferenceRecordingService }  from "./conferenceRecording.serviceInterface";

export class ConferenceRecordingServiceImpl implements ConferenceRecordingService {
    private simpleHttpAdapter: HttpAdapter;

    readonly #throwError: ThrowErrorFunction;

    constructor(ctx: ContextManager) {
        this.simpleHttpAdapter = new SimpleHttpAdapterImpl(ctx);
        this.#throwError = throwFlexSdkError(ctx);
        this.simpleHttpAdapter.setIsEdgeSupported();

    }

    








    public async updateConferenceRecording(accountSid: string, conferenceSid: string, sid: string, updateConferenceRecordingRequest: UpdateConferenceRecordingRequest, options?: object): Promise<ConferenceRecording> {
        const metadata = {
            module: "backend",
            severity: ErrorSeverity.Error,
            source: "conferenceRecording.service.ts"
        };
        if (accountSid === null || accountSid === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter accountSid was null or undefined.");
        }
        if (conferenceSid === null || conferenceSid === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter conferenceSid was null or undefined.");
        }
        if (sid === null || sid === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter sid was null or undefined.");
        }
        if (updateConferenceRecordingRequest === null || updateConferenceRecordingRequest === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter updateConferenceRecordingRequest was null or undefined.");
        }

        let response;
        try {
            response = await this.simpleHttpAdapter.post<ConferenceRecording>(`https://api[region].twilio.com/2010-04-01/Accounts/${encodeURIComponent(String(accountSid))}/Conferences/${encodeURIComponent(String(conferenceSid))}/Recordings/${encodeURIComponent(String(sid))}.json`, AuthenticationMethod.Basic, updateConferenceRecordingRequest, options, "application/x-www-form-urlencoded");
        } catch (e) {
            if (isDownstreamErrorCode(e.code)) {
                const message = `ConferenceRecordingService - ${e.message}`
                return this.#throwError(ErrorCode.DownstreamServiceError, metadata, message) as unknown as Promise<never>;;
            }

            return Promise.reject(e)
        }
        return response;
    }
}

